import Vue from 'vue';

export default Vue.mixin({
    methods: {
        filterBySearch
    }
});

function filterBySearch(items, getters, search) {
    var tokens = search.toLowerCase().trim().split(' ');

    if (tokens.length < 1) {
        return items;
    }

    return items.filter(item => itemMatchesAllTokens(item, getters, tokens));
}

function itemMatchesAllTokens(item, getters, tokens) {
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var isMatch = itemMatchesToken(item, getters, token);

        if (!isMatch) {
            return false;
        }
    }
    return true;
}

function itemMatchesToken(item, getters, token) {
    for (var i = 0; i < getters.length; i++) {
        var value = getters[i](item);

        if (includes(value, token)) {
            return true;
        }
    }
    return false;
}

function includes(value, token) {
    if (!value) {
        return false;
    }

    return ('' + value).toLowerCase().includes(token);
}
